import { alea } from 'seedrandom';

/**
 * Returns one item randomly but consistent on the same seed
 */
export const pickConsistentRandom = (seed: string): (<T>(arr: T[]) => T | undefined) => {
  const seedrandom = alea(seed);

  return <T>(arr: T[]): T | undefined => {
    const randomIndex = Math.floor(seedrandom() * arr.length);
    return arr[randomIndex];
  };
};
